import { useEffect } from 'react'

import { APP_NAME } from '@/constants'
import SsoAuthenticationHandler from '@/SsoAuthenticationHandler'
import AuthUtils from '@/utils/AuthUtils'
import { isProduction } from '@/utils/EnvironmentHelper'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import queryString from 'query-string'
import { DndProvider } from 'react-dnd'
import { HTML5Backend } from 'react-dnd-html5-backend'
import { Outlet, useNavigate } from 'react-router-dom'
import { QueryParamProvider } from 'use-query-params'
import { ReactRouter6Adapter } from 'use-query-params/adapters/react-router-6'

export default function Root() {
	const navigate = useNavigate()

	useEffect(() => {
		AuthUtils.onSsoAuthChange((token) => {
			if (token) {
				navigate('/app', { replace: true })
			}
			navigate('/login', { replace: true })
		})
	}, [navigate])

	document.title = APP_NAME

	return (
		<SsoAuthenticationHandler>
			<DndProvider backend={HTML5Backend}>
				<QueryParamProvider
					adapter={ReactRouter6Adapter}
					options={{
						searchStringToObject: queryString.parse,
						objectToSearchString: queryString.stringify,
					}}
				>
					<Outlet />
					{!isProduction && (
						<ReactQueryDevtools initialIsOpen={false} buttonPosition="bottom-left" />
					)}
				</QueryParamProvider>
			</DndProvider>
		</SsoAuthenticationHandler>
	)
}
